// extracted by mini-css-extract-plugin
export default {"transaction-volumes":"transaction-volumes","transactionVolumes":"transaction-volumes","col-12":"col-12","col12":"col-12","col-4":"col-4","col4":"col-4","image":"image"};